import { useState } from "react";
import { AlertDialog, AlertDialogContent, AlertDialogHeader, AlertDialogTitle, AlertDialogDescription, AlertDialogFooter, AlertDialogCancel } from "./ui/alert-dialog";
import { Loader2 } from "lucide-react";
import { errMsg } from "../lib/api";

export const ConfirmAction = ({ action, onClose }) => {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const confirm = async () => {
    setBusy(true); setError("");
    try { await action.run(); onClose(); }
    catch (e) { setError(errMsg(e, "Could not complete this action")); }
    finally { setBusy(false); }
  };
  return <AlertDialog open={!!action} onOpenChange={(open) => { if (!open && !busy) { setError(""); onClose(); } }}>
    <AlertDialogContent data-testid="confirm-action-dialog" className="max-w-md w-[calc(100vw_-_2rem)]">
      <AlertDialogHeader>
        <AlertDialogTitle data-testid="confirm-action-title">{action?.title}</AlertDialogTitle>
        <AlertDialogDescription data-testid="confirm-action-description">{action?.description}</AlertDialogDescription>
      </AlertDialogHeader>
      {error && <p role="alert" data-testid="confirm-action-error" className="text-sm text-destructive">{error}</p>}
      <AlertDialogFooter>
        <AlertDialogCancel disabled={busy} data-testid="confirm-action-cancel">Cancel</AlertDialogCancel>
        <button onClick={confirm} disabled={busy} data-testid="confirm-action-submit"
          className="inline-flex justify-center items-center gap-2 px-4 py-2 rounded-md bg-destructive text-destructive-foreground text-sm font-semibold disabled:opacity-60">
          {busy && <Loader2 size={16} className="animate-spin" />}{action?.label || "Confirm"}
        </button>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>;
};